import { BaseEntity, DefaultResponseWithData } from "./system";


export interface GetCustomerDetailsResponse extends DefaultResponseWithData<GetCustomerResponseData> { };
export interface GetCustomerFeatureResponse extends DefaultResponseWithData<GetFeatureResponse[]> { };
export interface GetCustomerBrandResponse extends DefaultResponseWithData<GetFullBrandResponse> { };


//**  Customer Details  **//
export interface GetCustomerResponseData extends BaseEntity {
  name: string;
  usernamePrefix: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  locality: string;
  town: string;
  county: string;
  postcode: string;
  domain: string;
  vatNumber: string;
  brand: GetCustomerResponseBrand;
}

export interface GetCustomerResponseBrand {
  logo: string;
  domain: string;
  primaryColour: number;
  secondaryColour: number;
}


//**  Customer Features  **//

export interface GetFeatureResponse extends BaseEntity {
  status: FeatureStatus;
  name: string;
}

export enum FeatureStatus {
  Archived,
  Disabled,
  Enabled,
  Preview
}


//**  Brand  **/
export interface GetFullBrandResponse {
  logo: string;
  croppedLogo: string;
  faviconUrl: string;
  favicon16Url: string;
  favicon32Url: string;
  appleTouchIconUrl: string;
  androidChrome192Url: string;
  androidChrome512Url: string;

  domain: string;

  lookupTokens: number;
  smsTokens: number;

  primaryColour: number;
  secondaryColour: number;
  primaryTailwindColours: { [key: number]: string; };
}